import minBy from 'lodash/minBy'
import maxBy from 'lodash/maxBy'

export const metersToPixelsAtMaxZoom = (meters: number, latitude: number): number =>
  meters / 0.075 / Math.cos((latitude * Math.PI) / 180)

const getMinOrMax = (
  coords: [number, number][],
  minOrMax: 'min' | 'max',
  latOrLng: 'lat' | 'lon'
): number => {
  if (minOrMax === 'max') {
    return maxBy(coords, (value) => value[latOrLng === 'lon' ? 0 : 1])![latOrLng === 'lon' ? 0 : 1]
  }
  return minBy(coords, (value) => value[latOrLng === 'lon' ? 0 : 1])![latOrLng === 'lon' ? 0 : 1]
}

export const getBoundsFromCoords = (coords: [number, number][]): [[number, number], [number, number]] => {
  const maxLat = getMinOrMax(coords, 'max', 'lat')
  const minLat = getMinOrMax(coords, 'min', 'lat')
  const maxLng = getMinOrMax(coords, 'max', 'lon')
  const minLng = getMinOrMax(coords, 'min', 'lon')
  const southWest: [number, number] = [minLng, minLat]
  const northEast: [number, number] = [maxLng, maxLat]
  return [southWest, northEast]
}

export const randomColor = (): string => {
  const n = (Math.random() * 0xfffff * 1000000).toString(16)
  return `#${n.slice(0, 6)}`
}
